import { render, staticRenderFns } from "./ProjectPrefundTab.vue?vue&type=template&id=27bfeeec&"
import script from "./ProjectPrefundTab.vue?vue&type=script&lang=js&"
export * from "./ProjectPrefundTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports